import { render, staticRenderFns } from "./VirtualDesktopEmpty.vue?vue&type=template&id=44bbaefa&scoped=true"
import script from "./VirtualDesktopEmpty.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopEmpty.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopEmpty.vue?vue&type=style&index=0&id=44bbaefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bbaefa",
  null
  
)

export default component.exports